module.exports = __webpack_public_path__ + "img/ic_nowithdrawal.473f977.svg";